import setupMixin from './../mixin';
import modalMixin from '../../../mixins/_modal';

/**
 * 配送グループ設定の編集モーダル画面
 */
export default {
    name: 'DeliveryGroupEditer',
    template: '#delivery_group_editer_template',
    data() {
        return {
            index: null,
            group: {},
        };
    },
    props: {
        // 配送データ一覧
        shippings: {
            type: Array,
            required: true
        },
        // 配送グループデータ一覧(設定名重複防止に使う)
        groups: {
            type: Array,
            required: true
        },
    },
    computed: {
        // すでに設定名が登録されているか
        isAlreadyPostageSetName: function () {
            const count = this.groups.filter( (group, index) => {
                // 自身(編集中)の設定名は除く
                if (index == this.index) {
                    return false;
                }
                if (group.postage_set_name !== this.group.postage_set_name) {
                    return false;
                }
                return true;
            }).length;
            if (count > 0) {
                return true;
            }
            return false;
        },
    },
    mixins: [
        setupMixin,
        modalMixin,
    ],
    emits: ['update-delivery-group'],
    methods: {
        // 設定画面を開く
        show: function (index, group) {
            this.index = index;
            this.group = _.cloneDeep(group);
            this.open();
        },
        // 編集を保存する
        save: function (event) {
            // グループ名未入力
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            // グループ名重複
            if (this.isAlreadyPostageSetName) {
                swal('すでに設定されている配送グループ名\n「' + this.group.postage_set_name + '」は使用できません');
                return;
            }
            // 未選択エラー
            if (!this.group.delivery_methods_auto_sync && this.group.delivery_methods.length === 0) {
                swal('配送方法を一つ以上選択してください');
                return;
            }
            this.emitUpdateDeliveryGroup();
            this.close();
        },
        // モーダルを閉じたらindexを初期化
        closed: function () {
            this.index = null;
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集データを通知
        emitUpdateDeliveryGroup: function() {
            this.$emit('update-delivery-group', this.index, this.group);
        }
    }
};
